import { render, staticRenderFns } from "./Band.vue?vue&type=template&id=29dde102&scoped=true&"
import script from "./Band.vue?vue&type=script&lang=js&"
export * from "./Band.vue?vue&type=script&lang=js&"
import style0 from "./Band.vue?vue&type=style&index=0&id=29dde102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dde102",
  null
  
)

export default component.exports